import React, { useState } from "react";
import { PopUpMenuComponents } from "@common/LifeAtPopupMenuV2/PopUpMenuComponents";
import { EmojiData, EmojiPicker, EmojiPickerProps } from "./EmojiPicker";

interface LifeAtEmojiPickerPopUpMenuProps {
    readonly children: React.ReactNode;
}
export function LifeAtEmojiPickerPopUpMenu(props: LifeAtEmojiPickerPopUpMenuProps & EmojiPickerProps) {
    const [isPopupOpen, setIsPopupOpen] = useState(false);

    return (
        <PopUpMenuComponents.Root
            open={isPopupOpen}
            onOpenChange={(isOpen: boolean) => setIsPopupOpen(isOpen)}
            modal={false}
        >
            <PopUpMenuComponents.Trigger>{props.children}</PopUpMenuComponents.Trigger>
            <PopUpMenuComponents.Content>
                <div
                    onClick={(e: React.MouseEvent<HTMLDivElement>) => {
                        e.stopPropagation();
                    }}
                >
                    <EmojiPicker
                        onEmojiSelect={(emoji: EmojiData) => {
                            props.onEmojiSelect(emoji);
                            setIsPopupOpen(false);
                        }}
                    />
                </div>
            </PopUpMenuComponents.Content>
        </PopUpMenuComponents.Root>
    );
}
